import { t } from '@lingui/core/macro';
import { getProjectContractTermLabels } from 'app/domains/projects';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { SearchStringFilter } from './SearchStringFilter';
export const projectContractTermFilterLabel = () => t({ message: 'Contract term', comment: 'Insights filter: Project ContractTerm' });
export const ProjectContractTermFilter = withFilterErrorBoundary(() => {
    const labels = getProjectContractTermLabels();
    const items = Object.entries(labels).map(([id, title]) => ({ id, title }));
    return (<SearchStringFilter name="metadataProjectContractTerm" items={items} label={projectContractTermFilterLabel()}/>);
});
